(() => {
  const panels = root => [...root.querySelectorAll('[data-iv-community-panel]')];
  function select(root, name, focus = false) {
    root.dataset.userSelected = name;
    root.querySelectorAll('[data-iv-community-tab]').forEach(tab => { const active = tab.dataset.ivCommunityTab === name; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; if(active && focus) tab.focus(); });
    panels(root).forEach(panel => panel.hidden = panel.dataset.ivCommunityPanel !== name);
    window.dispatchEvent(new Event('resize'));
  }
  function cleanEmpty(root) {
    if(Number(root.dataset.reviewCount) !== 0) return;
    root.querySelectorAll('#judgeme_product_reviews *').forEach(node => {
      if(node.children.length===0 && node.textContent.trim()==='No items found') node.hidden=true;
    });
  }
  function initialize() {
    document.querySelectorAll('[data-iv-community]').forEach(root => {
      if(root.dataset.ivCommunityReady) return;
      root.dataset.ivCommunityReady='true'; cleanEmpty(root);
      new MutationObserver(() => cleanEmpty(root)).observe(root,{childList:true,subtree:true});
    });
  }
  initialize(); document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('click',event => {
    const target = event.target.closest?.('[data-iv-community-tab]');
    if(target) select(target.closest('[data-iv-community]'), target.dataset.ivCommunityTab);
    const badge=event.target.closest?.('.jdgm-prev-badge, button[aria-label="See all reviews"]');
    if(badge && document.querySelector('[data-iv-community]')) select(document.querySelector('[data-iv-community]'),'reviews');
    const anchor = event.target.closest?.('a[href="#judgeme_product_reviews"], a[href="#IvCommunity"]');
    if(anchor && document.querySelector('[data-iv-community]')) {
      const root = document.querySelector('[data-iv-community]');
      if(anchor.hash === '#judgeme_product_reviews') select(root, 'reviews');
      event.preventDefault(); root.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
  });
  document.addEventListener('keydown',event => {
    const tab = event.target.closest?.('[data-iv-community-tab]'); if(!tab) return;
    const tabs=[...tab.parentElement.querySelectorAll('[role="tab"]')],index=tabs.indexOf(tab);
    let next; if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;
    event.preventDefault();select(tab.closest('[data-iv-community]'),tabs[next].dataset.ivCommunityTab,true);
  });
})();
